<template>
	<Teleport to="body">
		<div class="modal" :class="{ 'is-active': show }">
			<div class="modal-background" @click="close"></div>
			<div class="modal-card">
				<header class="modal-card-head">
					<p class="modal-card-title">{{ editingItem ? 'Edit item' : 'Add new item' }}</p>
					<button class="delete" aria-label="close" @click="close"></button>
				</header>
				<section class="modal-card-body">
					<div class="field">
						<label class="label">Images</label>
						<image-manager v-model:existing-src="existingImages" v-model:new-images="newImages"></image-manager>
					</div>
					<div class="field">
						<label class="label">Country</label>
						<div class="control">
							<div class="select is-fullwidth">
								<select v-model="country">
									<option v-for="c in countries" :key="c.name" :value="c.name">{{ c.name }}</option>
								</select>
							</div>
						</div>
					</div>
					<div class="field">
						<label class="label">Owned</label>
						<div class="control">
							<div class="select is-fullwidth">
								<select v-model="own">
									<option value="true">Yes</option>
									<option value="soon">On the way</option>
									<option value="false">No</option>
								</select>
							</div>
						</div>
					</div>
					<p class="help is-danger" v-if="error">{{ error }}</p>
					<p class="help is-danger" v-if="submitError">{{ submitError }}</p>
				</section>
				<footer class="modal-card-foot">
					<button class="button is-success" :class="{ 'is-loading': isSubmitting }" :disabled="isSubmitting" @click="submit">
						{{ editingItem ? 'Save' : 'Add' }}
					</button>
					<button class="button" @click="close">Cancel</button>
				</footer>
			</div>
		</div>
	</Teleport>
</template>

<script>
import ImageManager from '@/components/ImageManager.vue';

export default {
	name: 'AddDemoModal',
	components: { ImageManager },
	props: {
		show: Boolean,
		editingItem: { type: Object, default: null },
		countries: { type: Array, required: true },
		onSubmit: { type: Function, required: true },
	},
	emits: ['close'],
	data() {
		return {
			existingImages: [],
			newImages: [],
			country: this.countries[0] ? this.countries[0].name : '',
			own: 'true',
			error: '',
			isSubmitting: false,
			submitError: '',
		};
	},
	watch: {
		show(val) {
			if (val) this.populate();
		},
	},
	methods: {
		populate() {
			this.reset();
			if (this.editingItem) {
				this.existingImages = this.editingItem.image.src.slice();
				const match = this.countries.find((c) => c.name.toLowerCase() === this.editingItem.country);
				this.country = match ? match.name : this.countries[0].name;
				this.own = this.editingItem.own === 'soon' ? 'soon' : this.editingItem.own === false ? 'false' : 'true';
			}
		},
		async submit() {
			if (this.existingImages.length === 0 && this.newImages.length === 0) {
				this.error = 'Please add at least one image.';
				return;
			}
			this.error = '';
			this.submitError = '';
			const payload = {
				existingImages: this.existingImages,
				newImages: this.newImages.map((img) => img.data),
				country: this.country,
				own: this.own === 'soon' ? 'soon' : this.own === 'true',
			};
			this.isSubmitting = true;
			const result = await this.onSubmit({
				isEdit: !!this.editingItem,
				id: this.editingItem ? this.editingItem.id : null,
				payload,
			});
			this.isSubmitting = false;
			if (result && result.ok) {
				this.reset();
				this.$emit('close');
			} else {
				this.submitError = (result && result.error) || 'Could not save this item.';
			}
		},
		close() {
			this.reset();
			this.$emit('close');
		},
		reset() {
			this.existingImages = [];
			this.newImages = [];
			this.country = this.countries[0] ? this.countries[0].name : '';
			this.own = 'true';
			this.error = '';
			this.isSubmitting = false;
			this.submitError = '';
		},
	},
};
</script>

<style scoped>
.modal {
	z-index: 1000;
}
.modal-card {
	width: 420px;
	max-width: 90vw;
}
</style>
